module.exports = __webpack_public_path__ + "static/images/index-title.ba48d3888.png";